import api from './api';

const adminWorkingHoursService = {
  // Get all working hours configurations with pagination and filtering
  async getWorkingHoursConfigs(params = {}) {
    try {
      const response = await api.get('/admin/working-hours-config', { params });
      return response.data;
    } catch (error) {
      console.error('Failed to get working hours configs:', error);
      throw error;
    }
  },

  // Get working hours config by ID
  async getWorkingHoursConfig(id) {
    try {
      const response = await api.get(`/admin/working-hours-config/${id}`);
      return response.data;
    } catch (error) {
      console.error('Failed to get working hours config:', error);
      throw error;
    }
  },

  // Create new working hours config
  async createWorkingHoursConfig(configData) {
    try {
      const response = await api.post('/admin/working-hours-config', configData);
      return response.data;
    } catch (error) {
      console.error('Failed to create working hours config:', error);
      throw error;
    }
  },

  // Update working hours config
  async updateWorkingHoursConfig(id, configData) {
    try {
      const response = await api.put(`/admin/working-hours-config/${id}`, configData);
      return response.data;
    } catch (error) {
      console.error('Failed to update working hours config:', error);
      throw error;
    }
  },

  // Delete working hours config
  async deleteWorkingHoursConfig(id) {
    try {
      const response = await api.delete(`/admin/working-hours-config/${id}`);
      return response.data;
    } catch (error) {
      console.error('Failed to delete working hours config:', error);
      throw error;
    }
  }
};

export default adminWorkingHoursService;